// extracted by mini-css-extract-plugin
export default {"danmakuContainer":"style_danmakuContainer__evDaE","danmakuItem":"style_danmakuItem__a6Zzv","danmakuMove":"style_danmakuMove__tAeNb","danmakuText":"style_danmakuText__37KBM"};